var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonRunning(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.70584,
    height: 54.9062,
    viewBox: "0 0 40.70584 54.9062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fadcbc;}.cls-2{stroke-linecap:round;stroke-linejoin:round;}.cls-2,.cls-3{fill:none;stroke:#000;stroke-width:2px;}.cls-3{stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emoji"
  }, /*#__PURE__*/React.createElement("g", {
    id: "skin"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 7.9688,
    cy: 4,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.665,13.4912s.3038,3.708,3.3038,9.042c.2441,.4345,1.0312,1.708,1.0312,1.708l-6,11.665-.25,18h3.4238l1.8262-15,6-6,6-5v-4l-6-11"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "23 26.9062 30 36.9062 40.167 42.9062 39.167 45.9062 27 40.9062 18 32.9062"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17,12.9062c-2-4-4.3594-4.2329-6.0312-3.583-2.06485,.93983-2.97685,3.37561-2.03702,5.44046,.02182,.04795,.04457,.09547,.06822,.14254"
  })), /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 7.9688,
    cy: 4,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23,26.9062l5.8535,8.3613c.79059,1.04895,1.76226,1.94818,2.8692,2.6553l6.7216,3.9668c.91369,.48157,1.40883,1.50068,1.2227,2.5166-.40513,.84085-1.4152,1.19408-2.25605,.78895-.03182-.01533-.06316-.03165-.09395-.04895l-8.467-3.48c-1.20722-.53624-2.33312-1.23941-3.3447-2.0889l-7.5053-6.6711"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.8477,22.2656s.26,.5937,.5761,1.32c.26985,1.02777,.0887,2.12185-.498,3.0078l-4.8516,7.625c-.65024,1.12633-1.02749,2.38936-1.1015,3.6878l-.1954,14c-.08731,1.01721,.66652,1.91261,1.68373,1.99992l.00087,.00008c1.04531-.10315,1.86757-.93858,1.9541-1.9854l1.3418-11.0292c.219-1.26716,.79338-2.44607,1.6563-3.3995l3.1718-3.1718c.7774-.7774,2.1055-1.99,2.95-2.6944l2.928-2.4397c.91521-.8548,1.46543-2.02968,1.5361-3.28h0c-.05224-1.30532-.37865-2.58503-.958-3.7559l-5.042-9.2441"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17,12.9062c-2-4-4.3594-4.2329-6.0312-3.583-1.53136,.63629-2.48499,2.17979-2.3688,3.834"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.9375,12.9062l-1.4189,5.0771c-.35527,1.10426-1.35975,1.87116-2.5186,1.9229H1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonRunning);
export default __webpack_public_path__ + "static/media/person-running.37e6d914b2525b65c7ba9e9ca72808ea.svg";
export { ForwardRef as ReactComponent };